<script>
    import MarkdownIt from 'markdown-it';
    import Highlight from 'highlight.js';
    import abbreviation from 'markdown-it-abbr';
    import definitionlist from 'markdown-it-deflist';
    import emoji from 'markdown-it-emoji';
    import footnote from 'markdown-it-footnote';
    import insert from 'markdown-it-ins';
    import mark from 'markdown-it-mark';
    import smartarrows from 'markdown-it-smartarrows';
    import subscript from 'markdown-it-sub';
    import superscript from 'markdown-it-sup';
    import tasklists from 'markdown-it-task-lists';

    export default {
        name: 'VueMarkdownIt',
        props: {
            source: {
                type: String,
                default: '',
                required: true
            },
            tableClass: {
                type: String,
                default: 'table',
                required: false
            }
        },
        beforeCreate() {
            this.markdownIt = new MarkdownIt({
                html: false, // For security, never allow HTML tags.
                xhtmlOut: false, // Do not use '/' to close single tags (<br/>)
                breaks: false, // Do not convert '\n' in paragraphs to <br>
                linkify: true, // Auto-convert URL-like text to links.
                typographer: true, // Enable some language-neutral replacement + quotes beautification.
                highlight(str, lang) {
                    if (lang && Highlight.getLanguage(lang)) {
                        try {
                            return Highlight.highlight(lang, str).value;
                        } catch (__) {
                            // Intentionally empty.
                        }
                    }
                    return '';
                }
            })
                .disable('image') // Do not allow (external) images to be loaded.
                .use(abbreviation)
                .use(definitionlist)
                .use(emoji)
                .use(footnote)
                .use(insert)
                .use(mark)
                .use(smartarrows)
                .use(subscript)
                .use(superscript)
                .use(tasklists);
            this.markdownIt.renderer.rules.table_open = () => `<table class="${this.tableClass}">\n`;
            let defaultLinkRenderer = this.markdownIt.renderer.rules.link_open ||
                function (tokens, idx, options, env, self) {
                    return self.renderToken(tokens, idx, options)
                };
            this.markdownIt.renderer.rules.link_open = (tokens, idx, options, env, self) => {
                // Make sure links are safe.
                tokens[idx].attrPush(['target', '_blank']);
                tokens[idx].attrPush(['rel', 'noopener noreferrer']);
                tokens[idx].attrPush(['referrerpolicy', 'no-referrer']);
                return defaultLinkRenderer(tokens, idx, options, env, self);
            }
        },
        render(createElement) {
            return createElement('div', { domProps: { innerHTML: this.markdownIt.render(this.source) } });
        }
    }
</script>
